module.exports = __webpack_public_path__ + "img/sticker-0-4.60623acb.svg";